import React, { PureComponent } from 'react';
import StyledLayout from './Styled';
import { H4 } from '@rezdy/components/Heading';
import Icon from '@rezdy/components/Icon';
import TextStyle from '@rezdy/components/TextStyle';
import { WithTranslation, withTranslation } from 'react-i18next';
import * as i18nClass from '../../translations';

export class Layout extends PureComponent<WithTranslation> {
    render() {
        const { i18n } = this.props ?? { i18n: i18nClass };
        return (
            <>
                <StyledLayout.Body>
                    <StyledLayout.Left />
                    <StyledLayout.Center>
                        <StyledLayout.Form>
                            <TextStyle align="center">
                                <H4>
                                    {i18n.t('LOADING')} <Icon name="loader-dots" size="large" />
                                </H4>
                            </TextStyle>
                        </StyledLayout.Form>
                    </StyledLayout.Center>
                    <StyledLayout.Right />
                </StyledLayout.Body>
            </>
        );
    }
}

export default withTranslation()(Layout);
